import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { progressFlgState } from '../../GlobalState';
import { SelectIcon } from '../parts/cloudStorage/SelectIcon';
import {
  useStyles,
  ModalSubmitButton,
  ModalInnerButton
} from '../parts/cloudStorage/style/style';
import { PreviewField } from './Preview';
import {
  getFileFolders,
  getFileDetailsById,
  editFileDetailById
} from '../../apicalls/cloud/cloudFile';
import { getFileDownload } from '../../apicalls/cloudFile';
import { getFileTypes } from '../../apicalls/cloud/fileType';
import { getVendorList } from '../../apicalls/getVendorDetails';
import { Grid, Modal, TextField } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CloseIcon from '@material-ui/icons/Close';
import {
  formatDatetime,
  formatDataSize,
  checkResData
} from '../../utils/common';
import { useSnackbar } from 'notistack';

type TProps = {
  fileId: any;
  constructId: number;
  getFolderFileList: any;
  setOpenDetailModal: React.Dispatch<React.SetStateAction<boolean>>;
};

// 資料詳細
export const FileDetailField: React.FC<TProps> = (props: TProps) => {
  const { fileId, constructId, getFolderFileList, setOpenDetailModal } = props;

  // メッセージ
  const { enqueueSnackbar } = useSnackbar();
  // プレビュー
  const [src, setSrc] = useState<string>('');
  const [openPreview, setOpenPreview] = useState<boolean>(false);

  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);

  const classes = useStyles();
  const history = useHistory();

  // 資料種別一覧
  const [fileTypes, setFileTypes] = useState<any>([]);
  // 業者一覧
  const [vendorList, setVendorList] = useState<any>([]);
  // 作成しているフォルダ一覧
  const [fileFolders, setFileFolders] = useState<any>([]);
  // ファイル詳細用
  const [fileDetail, setFileDetail] = useState<any>([]);

  // ファイル詳細編集用 -react hook from 実装後に不要
  const [fileDetailName, setFileDetailName] = useState<string>('');
  const [fileDetailFileTypeId, setFileDetailFileTypeId] = useState<number>(0);
  const [fileDetailFileTypeName, setFileDetailFileTypeName] =
    useState<string>('');
  const [fileDetailFileFolderId, setFileDetailFileFolderId] =
    useState<number>(0);
  const [fileDetailSendTo, setFileDetailSendTo] = useState<number>(0);
  const [fileDetailSendToName, setFileDetailSendToName] = useState<string>('');
  const [fileDetailReceiveFrom, setFileDetailReceiveFrom] = useState<number>(0);
  const [fileDetailReceiveFromName, setFileDetailReceiveFromName] =
    useState<string>('');
  const [fileDetailAmount, setFileDetailAmount] = useState<number>(0);
  const [fileDetailExchangeDate, setFileDetailExchangeDate] =
    useState<string>('');
  const [fileDetailDescription, setFileDetailDescription] =
    useState<string>('');

  // 書類の詳細を取得
  const getFileDetail = (id: number) => {
    getFileDetailsById(id).then(resData => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        setFileDetail(data.data);

        // 詳細をstateに -react hook from 実装後に不要
        setFileDetailName(data.data.name);
        setFileDetailFileTypeId(data.data.file_type_id);
        setFileDetailFileTypeName(data.data.file_type_name);
        setFileDetailFileFolderId(data.data.file_folder_id);
        setFileDetailSendTo(data.data.send_to);
        setFileDetailSendToName(data.data.send_to_name);
        setFileDetailReceiveFrom(data.data.receive_from);
        setFileDetailReceiveFromName(data.data.receive_from_name);
        setFileDetailAmount(data.data.amount);
        setFileDetailExchangeDate(data.data.exchange_date);
        setFileDetailDescription(
          data.data.description ? data.data.description : ''
        );
      });
    });
  };

  // 資料種別一覧を取得
  const getAllFileTypes = () => {
    getFileTypes().then(resData => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        setFileTypes(data.data);
      });
    });
  };

  // 案件(contract_id)を指定してフォルダー覧を取得
  const getAllFileFolders = () => {
    getFileFolders(constructId).then(resData => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        setFileFolders(data.data);
      });
    });
  };

  const onDownload = async (id: number, documentTypeDetail: string) => {
    setProgressFlg(true);

    await getFileDownload(String(id), true).then((data: any) => {
      if (data === 'Not logged in!') {
        history.push('/');
      } else {
        if (typeof data === 'string') {
          console.log(data);
        } else {
          if (data.error) {
            console.log(data.error);
          } else {
            // 書類ダウンロード
            let bin = atob(data.data.replace(/^.*,/, ''));

            let buffer = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) {
              buffer[i] = bin.charCodeAt(i);
            }

            let fileData = new File([buffer.buffer], data.data, {
              type: data.file_format
            });

            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(fileData);
            const fileName = `${documentTypeDetail}`;
            downloadLink.download = fileName;
            downloadLink.click();
          }
        }
      }
      setProgressFlg(false);
    });
  };

  const PdfPreview = async (id: number) => {
    setProgressFlg(true);
    await getFileDownload(String(id), false).then((data: any) => {
      if (data === 'Not logged in!') {
        history.push('/');
      } else {
        if (typeof data === 'string') {
          console.log(data);
        } else {
          if (data.error) {
            console.log(data.error);
          } else {
            let bin = atob(data.data.replace(/^.*,/, ''));

            let buffer = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) {
              buffer[i] = bin.charCodeAt(i);
            }

            let image_file = new File([buffer.buffer], data.data, {
              type: data.file_format
            });
            setSrc(URL.createObjectURL(image_file));
            setOpenPreview(true);
          }
        }
      }
      setProgressFlg(false);
    });
  };

  // ファイル更新
  const editFile = () => {
    editFileDetailById(
      fileId,
      fileDetailName,
      fileDetail.construct_id,
      fileDetailFileFolderId,
      fileDetailFileTypeId,
      fileDetailFileTypeName,
      fileDetailAmount,
      fileDetailSendTo,
      fileDetailSendToName,
      fileDetailReceiveFrom,
      fileDetailReceiveFromName,
      fileDetailExchangeDate,
      fileDetail.name,
      fileDetailDescription
    ).then(resData => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        getFolderFileList();
        setTimeout(() => {
          setOpenDetailModal(false);
        }, 2000);
      });
    });
  };

  // 業者一覧取得
  const getListOfVendors = () => {
    getVendorList().then(resData => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        setVendorList(data.data);
      });
    });
  };

  // ページ開いた時に実行
  useEffect(() => {
    getAllFileTypes();
    getAllFileFolders();
    getListOfVendors();
    getFileDetail(fileId);
  }, []);

  return (
    <>
      {/* <FormProvider {...methods}> */}
      <form className={classes.paper}>
        <Grid container>
          {/* クローズボタン */}
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 32,
              paddingBottom: 30
            }}
          >
            {/* ファイル名 */}
            <div className={classes.modalTitle} style={{ border: 'none' }}>
              <div style={{ marginLeft: 24, marginRight: 20 }}>
                <SelectIcon
                  format={fileDetail.format}
                  name={fileDetailName}
                  width={30}
                />
              </div>
              <div style={{ marginBottom: 8 }}>{fileDetail.name}</div>
            </div>
            <CloseIcon
              style={{ fontSize: 36, cursor: 'pointer' }}
              onClick={() => {
                setOpenDetailModal(false);
              }}
            />
          </Grid>
          {/* モーダル左側 */}
          <Grid
            item
            xs={9}
            className={classes.modalLeft}
            style={{ borderTop: '1px solid #cfcfcf', paddingLeft: 40 }}
          >
            {/* 入力フォーム */}
            <table style={{ marginTop: 24 }}>
              <tr>
                <th className={classes.tableHead}>書類名</th>
                <td>
                  <TextField
                    className={`${classes.tableBody} ${classes.customTextField}`}
                    variant='outlined'
                    value={fileDetailName}
                    onChange={e => {
                      setFileDetailName(e.target.value);
                    }}
                  />
                </td>
                <th></th>
                <td></td>
              </tr>

              <tr>
                <th className={classes.tableHead}>資料種別</th>
                <td>
                  <select
                    className={`${classes.selectBoxStyle} ${classes.customTextField}`}
                    value={fileDetailFileTypeId} //資料種別のid
                    onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                      setFileDetailFileTypeId(e.target.value as number);
                    }}
                  >
                    <option value={''}></option>
                    {fileTypes.map((i: any) => (
                      <option value={i.id}>{i.name}</option>
                    ))}
                  </select>
                </td>
                <th></th>
                <td></td>
              </tr>

              <tr>
                <th className={classes.tableHead}>フォルダ</th>
                <td>
                  <select
                    className={classes.selectBoxStyle}
                    value={fileDetailFileFolderId}
                    onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                      setFileDetailFileFolderId(e.target.value as number);
                    }}
                  >
                    {/* <MenuItem value="0">未選択</MMenuItem>  */}
                    {fileFolders.map((i: any) => (
                      <option value={i.id}>{i.name}</option>
                    ))}
                  </select>
                </td>
                <th></th>
                <td></td>
              </tr>

              <tr>
                <th className={classes.tableHead}>送付先</th>
                <td>
                  <select
                    className={classes.selectBoxStyle}
                    value={fileDetailSendTo}
                    onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                      const selectedId = e.target.value as number;
                      setFileDetailSendTo(selectedId);
                      const selectedVendor = vendorList.find(
                        (vendor: any) => vendor.id === selectedId
                      );
                      setFileDetailSendToName(
                        selectedVendor ? selectedVendor.name : ''
                      );
                    }}
                  >
                    <option value={''}></option>
                    {vendorList.map((i: any) => (
                      <option value={i.id}>{i.name}</option>
                    ))}
                  </select>
                </td>
                <th className={classes.tableHead}>日付</th>
                <td>
                  <TextField
                    className={classes.customTextField}
                    variant='outlined'
                    type='date'
                    value={fileDetailExchangeDate}
                    onChange={e => {
                      setFileDetailExchangeDate(e.target.value);
                    }}
                    style={{ paddingBottom: 10 }}
                  />
                </td>
              </tr>

              <tr>
                <th className={classes.tableHead}>受取元</th>
                <td>
                  <select
                    className={classes.selectBoxStyle}
                    value={fileDetailReceiveFrom}
                    onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                      setFileDetailReceiveFrom(e.target.value as number);
                    }}
                  >
                    <option value={''}></option>
                    {vendorList.map((i: any) => (
                      <option value={i.id}>{i.name}</option>
                    ))}
                  </select>
                </td>
                <th className={classes.tableHead}>金額</th>
                <td style={{ display: 'flex', alignItems: 'end' }}>
                  <TextField
                    className={classes.customTextField}
                    variant='outlined'
                    type='number'
                    value={fileDetailAmount}
                    onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                      setFileDetailAmount(e.target.value as number);
                    }}
                    onWheel={(e: any) => e.target.blur()}
                  />
                  円
                </td>
              </tr>

              <tr>
                <th className={classes.tableHead}>
                  説明
                  <br />
                  <span style={{ fontSize: 12 }}>（200文字以内）</span>
                </th>
                <td colSpan={3}>
                  <TextField
                    className={classes.description}
                    value={fileDetailDescription}
                    rows={3}
                    multiline={true}
                    onChange={e => {
                      setFileDetailDescription(e.target.value);
                    }}
                    variant='outlined'
                    style={{ marginTop: 10 }}
                  />
                </td>
                <th></th>
                <td></td>
              </tr>
            </table>
          </Grid>

          {/* モーダル右側 */}
          <Grid
            item
            xs={3}
            className={classes.modalRight}
            style={{ paddingRight: 40 }}
          >
            <div>
              <span style={{ marginRight: 12, marginBottom: 8 }}>作成日</span>
              {formatDatetime(
                new Date(fileDetail.created_at),
                'YYYY.MM.DD',
                '日本標準時'
              )}
            </div>
            <div>
              <span style={{ marginRight: 12 }}>作成者</span>
              {fileDetail.created_name}
            </div>
            <div>
              <span style={{ marginRight: 12 }}>サイズ</span>
              {formatDataSize(fileDetail.size)}
            </div>
            <div style={{ marginTop: 24 }}>
              {fileDetail.format == 'application/pdf' && (
                <ModalInnerButton
                  variant='contained'
                  onClick={() => {
                    PdfPreview(fileDetail.id);
                  }}
                >
                  <VisibilityIcon />
                  PDFプレビュー
                </ModalInnerButton>
              )}
              <ModalInnerButton
                variant='contained'
                onClick={() => {
                  onDownload(fileDetail.id, fileDetail.name);
                }}
              >
                <GetAppIcon />
                ダウンロード
              </ModalInnerButton>
            </div>
          </Grid>

          {/* モーダルフッター */}
          <Grid item xs={12} className={classes.modalFooter}>
            <ModalSubmitButton
              variant='contained'
              onClick={() => {
                editFile();
              }}
            >
              更新する
            </ModalSubmitButton>
          </Grid>
        </Grid>
      </form>
      {/* </FormProvider> */}

      {/* プレビュー */}
      <Modal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%'
        }}
        open={openPreview}
        onClose={() => setOpenPreview(false)}
      >
        <PreviewField
          src={src}
          openPreview={openPreview}
          setOpenPreview={setOpenPreview}
        />
      </Modal>
    </>
  );
};
